import React from 'react';
import SuperProfileWorkplaceDetailsInput from './SuperProfileWorkplaceDetailsInput';
import SuperProfileRequiredMinimumEducationInput from './SuperProfileRequiredMinimumEducationInput';
import SuperProfileEducationRelevanceInput from './SuperProfileEducationRelevanceInput';
import SuperProfileRequiredJobSeniority from './SuperProfileRequiredJobSeniority';
import SuperProfileJobSeniorityRelevanceInput from './SuperProfileJobSeniorityRelevanceInput';
import SuperProfileRequiredManagementExperience from './SuperProfileRequiredManagementExperience';
import SuperProfileRequiredLanguageProficiencies from './SuperProfileRequiredLanguageProficiencies';
import SuperProfileOccupationalLevelInput from './SuperProfileOccupationalLevelInput';
import SuperProfileWorkAreaInput from './SuperProfileWorkAreaInput';
import SuperProfileWorkCategoryInput from './SuperProfileWorkCategoryInput';

const QualificationsAndRequirementsInput = ({ availableCountries, availableLanguages }) => {
  return (
    <div className="p-grid">
      <div className="p-col-12">
        <SuperProfileOccupationalLevelInput />
        <SuperProfileWorkCategoryInput />
        <SuperProfileWorkAreaInput />
        <SuperProfileWorkplaceDetailsInput availableCountries={availableCountries} />
        <SuperProfileRequiredMinimumEducationInput />
        <SuperProfileEducationRelevanceInput />
        <SuperProfileRequiredJobSeniority />
        <SuperProfileJobSeniorityRelevanceInput />
        <SuperProfileRequiredManagementExperience />
        <SuperProfileRequiredLanguageProficiencies availableLanguages={availableLanguages} />
      </div>
    </div>
  );
};

export default QualificationsAndRequirementsInput;
